module.exports = __webpack_public_path__ + "static/img/bussinessTv2.fa61f4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bussinessTv2.png
// module id = +0mO
// module chunks = 2